import axios, { AxiosRequestConfig } from "axios";
import qs from 'qs';
import * as actions from "./actionTypes";
const productUrl = "https://betastore-staging.herokuapp.com/api/v1/products";
const storeUrl = "https://betastore-staging.herokuapp.com/api/v1/clients";
const clientUrl = "https://betastore-staging.herokuapp.com/api/v1/clients/login";
const dispachGetProducts = (payload) => {
  return {
    type: actions.FETCH_PRODUCTS,
    payload
  };
};

const dispachGetStores = (payload) => {
  return {
    type: actions.FETCH_STORES,
    payload
  }
}

const makeRequest = (payload) => {
  return {
    type: actions.REQUEST,
    payload
  };
};

const requestError = (payload) => {
  return {
    type: actions.ERROR,
    payload
  };
};

const loginError = (payload) => {
  return {
    type: actions.LOGIN_ERROR,
    payload
  };
}

export const getProducts = () => async (dispatch) => {
  try {
    dispatch(makeRequest(true));
    axios
      .get(productUrl)
      .then((response) => {
        dispatch(dispachGetProducts(response.data.data));
      })
      .catch((error) => {
        dispatch(requestError(true));
      })
      .finally(() => {
        dispatch(makeRequest(false));
      });
  } catch (e) {
    dispatch(requestError(true));
  }
};

export const getStores = () => async (dispatch) => {
  try {
    dispatch(makeRequest(true));
    axios
      .get(storeUrl)
      .then((response) => {
        dispatch(dispachGetStores(response.data.data));
      })
      .catch((error) => {
        dispatch(requestError(true));
      })
      .finally(() => {
        dispatch(makeRequest(false));
      });
  } catch (e) {
    dispatch(requestError(true));
  }
};

/**
*  used to log the user in
* @params url, data, pushUrl, action, usertype
*/
export const login = (url, data, pushUrl, action, userType) => async (dispatch) => {

  const config: AxiosRequestConfig = {
      method: 'post',
      url,
      headers: { },
      data : qs.stringify(data),
    };

  try {
    dispatch(makeRequest(true));
    axios(config)
      .then((response) => {
        dispatch(setToken(response.data.data.token, userType))
        action.push(pushUrl)
      })
      .catch((error) => {
        console.log(data)
        dispatch(loginError({
          state: true,
          message: error.details
        }))
      })
      .finally(() => {
        dispatch(makeRequest(false));
      });
  } catch (error) {
    dispatch(loginError({
          state: true,
          message: "A server side error occured"
        }))
  }
}

export const signUp = (data, action) => async (dispatch) => {
  const loginData = {
    "phone_no": data.phone_no,
    "password": data.password      
  }

  const config: AxiosRequestConfig = {
      method: 'post',
      url: storeUrl,
      headers: { },
      data : qs.stringify(data),
    };

  try {
    dispatch(makeRequest(true));
    axios(config)
      .then((response) => {
        dispatch(login(clientUrl, loginData, '/', action, 'clients'))
      })
      .catch((error) => {
        dispatch(loginError({
          state: true,
          message: 'That phone number has already been registered'
        }))
      })
      .finally(() => {
        dispatch(makeRequest(false));
      });
  } catch (error) {
    dispatch(loginError({
          state: true,
          message: 'An error occured at the server side, please try again'
        }))
  }
}

export const setToken = (token, userType) => async (dispatch) => {
  dispatch({
    type: actions.SET_TOKEN,
    payload: token,
  });

  dispatch({
    type: actions.SET_AUTH,
    payload: true
  });

  dispatch({
    type: actions.SET_USERTYPE,
    payload: userType,
  });
};
